import { writable } from 'svelte/store';
// Models
import Bet from '@/Models/Bet.js';
import collect from 'collect.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	let meta = { pagination: {} };

	const { subscribe, set, update } = writable(collect());

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getFilterMeta() {
			if (meta && meta.pagination) {
				// eslint-disable-next-line no-unused-vars
				const { pagination, ...filterMeta } = meta;
				return filterMeta.available_filters;
			}
			return meta;
		},

		getUserBetHistory(userId, pagination = null, filter = null) {
			let bet = new Bet();
			// we need a custom resource URL for this endpoint
			bet.resourceUrl = () => {
				return `${bet.baseUrl()}/users/${userId}/${bet.resourceName()}/`;
			};

			if (filter) {
				for (const [key, value] of Object.entries(filter)) {
					if (value.toString().length) {
						bet = bet.where(key, value.toString());
					}
				}
			}

			let results = pagination ? bet.paginate(pagination.size, pagination.number) : bet.all();
			return results
				.then((result) => {
					meta = result.meta;
					set(result.data);
				})
				.catch((e) => {
					console.error(e);
				});
		},

		cancelUserBet(betId, data) {
			let bet = new Bet();

			return bet.cancel(betId, data).then((results) => {
				return results;
			});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
